<template>
    <div class="suspend-card">
        <div class="suspend-card__header">
            <div class="suspend-card__title">ВІДСТОРОНЕННЯ</div>
            <div v-if="players && players.length" class="suspend-card__count">{{ players.length }}</div>
        </div>
        <div class="suspend-card__list">
                <div
                    v-for="player in players"
                    :key="(player.player_id || player.name) + '-' + (player.match_report_id || player.number)"
                    class="suspend-card__player"
                >
                <div class="suspend-card__number">
                    {{ player.number }}
                </div>

                <div class="suspend-card__info">
                    <div class="suspend-card__name">{{ player.name }}</div>
                    <div class="suspend-card__team">{{ player.team }}</div>
                </div>

                <div v-if="player.rating" class="suspend-card__rating">
                    {{ player.rating }}
                </div>

                <div
                    class="suspend-card__cards"
                    :class="cardClass(player)"
                    :title="player.reason === 'red_card' ? 'Червона картка' : 'Дві жовті'"
                >
                    {{ badgeValue(player) }}
                </div>
            </div>

            <div v-if="!players || players.length === 0" class="suspend-card__empty">
                Немає відсторонених гравців
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SuspensionsList',

    props: {
        players: {
            type: Array,
            required: true
        }
    },

    methods: {
        cardClass(player) {
            const red = Number(player?.red_cards) || 0
            const yellow = Number(player?.yellow_cards) || 0
            const reason = player?.reason
            if (red >= 1 || reason === 'red_card' || yellow >= 3) {
                return 'suspend-card__cards--danger'
            }
            if (yellow >= 2 || reason === 'second_yellow') {
                return 'suspend-card__cards--warn'
            }
            return 'suspend-card__cards--caution'
        },

        badgeValue(player) {
            if (player?.yellow_cards != null) return player.yellow_cards
            if (player?.red_cards >= 1 || player?.reason === 'red_card') return 3
            if (player?.reason === 'second_yellow') return 2
            return '—'
        }
    }
}
</script>

<style scoped>
.suspend-card {
    background: linear-gradient(145deg, #2a2b2b 0%, #252626 100%);
    border: 1px solid #3a3b3b;
    border-radius: 14px;
    padding: 14px 16px 12px;
}
.suspend-card__header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}
.suspend-card__title {
    color: #C59014;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.3px;
}
.suspend-card__count {
    background: rgba(197, 144, 20, 0.2);
    color: #C59014;
    font-size: 11px;
    font-weight: 700;
    padding: 1px 8px;
    border-radius: 10px;
}
.suspend-card__list {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.suspend-card__player {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 8px;
    border-radius: 10px;
    transition: background 0.15s;
}
.suspend-card__player:hover {
    background: rgba(197, 144, 20, 0.08);
}
.suspend-card__number {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: linear-gradient(135deg, #3a3b3b 0%, #333 100%);
    border: 1px solid #484848;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #C59014;
    font-weight: 700;
    font-size: 14px;
    flex-shrink: 0;
}
.suspend-card__info {
    flex: 1;
    min-width: 0;
}
.suspend-card__name {
    color: #eee;
    font-size: 13px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.suspend-card__team {
    color: #666;
    font-size: 11px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.suspend-card__rating {
    color: #f0e6cc;
    font-weight: 700;
    font-size: 16px;
    margin-right: 4px;
    font-variant-numeric: tabular-nums;
}
.suspend-card__cards {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a1a1a;
    font-weight: 700;
    font-size: 12px;
    flex-shrink: 0;
}
.suspend-card__cards--danger {
    background: linear-gradient(135deg, #e53935, #c62828);
    color: #fff;
}
.suspend-card__cards--warn {
    background: linear-gradient(135deg, #f9a825, #f57f17);
}
.suspend-card__cards--caution {
    background: linear-gradient(135deg, #fdd835, #fbc02d);
}
.suspend-card__empty {
    color: #666;
    font-size: 13px;
    text-align: center;
    padding: 16px 0;
}
</style>
